import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { dashboardService } from '../../services/dashboardService';
import moment from 'moment';

const initialState = {
  loading: false,
  dashboardData: null,
  error: null,
  trendYear: moment().year(),
  cpdData: null,
  cpdLoading: false,
  cpdError: null,
  renewalData: null,
  renewalLoading: false,
  renewalError: null,
  applicationData: null,
  applicationLoading: false,
  applicationError: null,
};
// Conditionally add start_date and end_date if they are not null

export const fetchDashboardOverview = createAsyncThunk(
  'dashboard/fetchDashboardOverview',
  async ({ start_date, end_date, trend_year, tab_type }, thunkAPI) => {
    const payload = {
      trend_year,
    };
    if (start_date) {
      payload.start_date = moment(new Date(start_date)).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
    }

    if (end_date) {
      payload.end_date = moment(new Date(end_date)).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
    }

    if (tab_type) {
      payload.tab_type = tab_type;
    }

    try {
      const response = await dashboardService.getDashboardData(payload);
      return response?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const fetchCpdOverviewDetails = createAsyncThunk(
  'dashboard/fetchCpdOverviewDetails',
  async ({ start_date, end_date, trend_year, tab_type }, thunkAPI) => {
    const payload = {
      trend_year,
    };
    if (start_date) {
      payload.start_date = moment(new Date(start_date)).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
    }

    if (end_date) {
      payload.end_date = moment(new Date(end_date)).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
    }

    if (tab_type) {
      payload.tab_type = tab_type;
    }

    try {
      const response = await dashboardService.getCpdOverviewDetails(payload);
      return response?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const fetchRenewalOverviewDetails = createAsyncThunk(
  'dashboard/fetchRenewalOverviewDetails',
  async ({ start_date, end_date, trend_year, tab_type }, thunkAPI) => {
    const payload = {
      trend_year,
    };
    if (start_date) {
      payload.start_date = moment(new Date(start_date)).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
    }

    if (end_date) {
      payload.end_date = moment(new Date(end_date)).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
    }

    if (tab_type) {
      payload.tab_type = tab_type;
    }

    try {
      const response = await dashboardService.getRenewalOverviewDetails(payload);
      return response?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const fetchApplicationOverviewDetails = createAsyncThunk(
  'dashboard/fetchApplicationOverviewDetails',
  async ({ start_date, end_date, trend_year, tab_type }, thunkAPI) => {
    const payload = {
      trend_year,
    };
    if (start_date) {
      payload.start_date = moment(new Date(start_date)).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
    }

    if (end_date) {
      payload.end_date = moment(new Date(end_date)).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
    }

    if (tab_type) {
      payload.tab_type = tab_type;
    }

    try {
      const response = await dashboardService.getApplicationOverviewDetails(payload);
      return response?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setTrendYear: (state, action) => {
      state.trendYear = action.payload;
    },
    logoutdashboard: (state, action) => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardOverview.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDashboardOverview.fulfilled, (state, action) => {
        state.loading = false;
        state.dashboardData = action.payload;
      })
      .addCase(fetchDashboardOverview.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchCpdOverviewDetails.pending, (state) => {
        state.cpdLoading = true;
        state.cpdError = null;
      })
      .addCase(fetchCpdOverviewDetails.fulfilled, (state, action) => {
        state.cpdLoading = false;
        state.cpdData = action.payload;
      })
      .addCase(fetchCpdOverviewDetails.rejected, (state, action) => {
        state.cpdLoading = false;
        state.cpdError = action.payload;
      })
      .addCase(fetchRenewalOverviewDetails.pending, (state) => {
        state.renewalLoading = true;
        state.renewalError = null;
      })
      .addCase(fetchRenewalOverviewDetails.fulfilled, (state, action) => {
        state.renewalLoading = false;
        state.renewalData = action.payload;
      })
      .addCase(fetchRenewalOverviewDetails.rejected, (state, action) => {
        state.renewalLoading = false;
        state.renewalError = action.payload;
      })
      .addCase(fetchApplicationOverviewDetails.pending, (state) => {
        state.applicationLoading = true;
        state.applicationError = null;
      })
      .addCase(fetchApplicationOverviewDetails.fulfilled, (state, action) => {
        state.applicationLoading = false;
        state.applicationData = action.payload;
      })
      .addCase(fetchApplicationOverviewDetails.rejected, (state, action) => {
        state.applicationLoading = false;
        state.applicationError = action.payload;
      });
  },
});

export const { setTrendYear, logoutdashboard } = dashboardSlice.actions;
export default dashboardSlice.reducer;
